module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('md-card', {
    staticClass: "card",
    staticStyle: {
      "margin": "1rem"
    }
  }, [_c('md-card-content', [_c('md-layout', {
    staticStyle: {
      "position": "relative !important"
    },
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticStyle: {
      "z-index": "999"
    },
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-button', {
    staticClass: "\n              md-raised md-primary md-button-color md-theme-default\n              back\n              heght-1px\n            ",
    on: {
      "click": _vm.previousFFView
    }
  }, [_vm._v("« Back")])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "justify-content-center",
    staticStyle: {
      "position": "absolute"
    },
    attrs: {
      "md-flex": "100"
    }
  }, [_c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Assignment Notes")])])], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-warning direct-chat direct-chat-warning"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Internal Chat")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body",
    staticStyle: {
      "border": "1px solid #e7e7e7"
    }
  }, [_c('div', {
    staticClass: "direct-chat-messages",
    attrs: {
      "id": "internalChat"
    }
  }, _vm._l((_vm.internalChat2), function(item, index) {
    return _c('ul', {
      key: index + '_chat',
      staticStyle: {
        "padding": "0",
        "margin": "0"
      }
    }, [_c('div', {
      staticClass: "direct-chat-msg"
    }, [_c('div', {
      staticClass: "direct-chat-info clearfix"
    }, [_c('span', {
      staticClass: "direct-chat-name pull-left"
    }, [_vm._v("Assigned By : " + _vm._s(item.employeeName))]), _vm._v(" "), _c('span', {
      staticClass: "direct-chat-timestamp pull-right"
    }, [_vm._v(_vm._s(_vm._f("moment")(item.loginTime)))])]), _vm._v(" "), _c('md-icon', {
      staticClass: "md-size-2x nav-icon"
    }, [_vm._v("person_outline")]), _vm._v(" "), _c('div', {
      staticClass: "direct-chat-text"
    }, [_vm._v("\n                      " + _vm._s(item.remarkMsg) + "\n\n                      ")]), _vm._v(" "), _c('b-form-checkbox', {
      attrs: {
        "v-model": item.flage ? true : false,
        "disabled": item.value == '2' ? true : false,
        "name": "check-button",
        "switch": ""
      },
      on: {
        "change": function($event) {
          _vm.UpdateMessageStatus(item.taskId, '2')
        }
      }
    }, [(item.value == '2') ? _c('b', [_vm._v("Completed ")]) : _vm._e(), _vm._v("  \n                      "), (item.msg_status_updated) ? _c('span', {
      staticClass: "direct-chat-timestamp pull-right"
    }, [_vm._v(_vm._s("" + item.msg_status_updated))]) : _vm._e()]), _vm._v(" "), (item.assignedUsersName != '') ? _c('span', {
      staticClass: "direct-chat-name pull-left"
    }, [_vm._v("Assigned To : " + _vm._s(item.assignedUsersName))]) : _vm._e()], 1)])
  }))])])])]), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pr-4",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Internal")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": true,
      "option-value": "typeV",
      "option-text": "typeT",
      "list": _vm.typeList,
      "placeholder": "Select "
    },
    model: {
      value: (_vm.updateModal.msgType),
      callback: function($$v) {
        _vm.$set(_vm.updateModal, "msgType", $$v)
      },
      expression: "updateModal.msgType"
    }
  }), _vm._v(" "), (!_vm.updateModal.msgType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorDocModal.msgType))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "itemDescription"
    }
  }, [_vm._v("Message")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "remark",
      "name": "remark",
      "row": "5"
    },
    model: {
      value: (_vm.updateModal.remarkMsg),
      callback: function($$v) {
        _vm.$set(_vm.updateModal, "remarkMsg", $$v)
      },
      expression: "updateModal.remarkMsg"
    }
  }), _vm._v(" "), (!_vm.updateModal.remarkMsg) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorDocModal.remarkMsg))]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "justify-content-center mt-2",
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-button', {
    staticClass: "\n              md-raised md-primary md-button-color md-theme-default\n              back\n              heght-1px\n            ",
    attrs: {
      "id": "addButtonLoader1"
    },
    on: {
      "click": _vm.sendUpdate
    }
  }, [_vm._v("Send")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader1"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gutr"
  }), _vm._v(" "), _c('b-modal', {
    ref: "UpdateMessageStatusModal-modal",
    attrs: {
      "id": "UpdateMessageStatusModal-modal",
      "title": "Update Message Status",
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.taskMSGMaster,
      "id": "taskMSGId",
      "option-value": "taskId",
      "option-text": "taskTitle",
      "placeholder": "Select Task Title"
    },
    model: {
      value: (_vm.updateMSGStatus.taskMSGId),
      callback: function($$v) {
        _vm.$set(_vm.updateMSGStatus, "taskMSGId", $$v)
      },
      expression: "updateMSGStatus.taskMSGId"
    }
  }), _vm._v(" "), (!_vm.updateMSGStatus.taskMSGId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorupdateMSGStatus.taskMSGId))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.categoryTypeList,
      "option-value": "categoryTypeVal",
      "option-text": "categoryTypeTxt",
      "placeholder": "Select Status"
    },
    model: {
      value: (_vm.updateMSGStatus.taskStatus),
      callback: function($$v) {
        _vm.$set(_vm.updateMSGStatus, "taskStatus", $$v)
      },
      expression: "updateMSGStatus.taskStatus"
    }
  }), _vm._v(" "), (!_vm.updateMSGStatus.taskStatus) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorupdateMSGStatus.taskStatus))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text center mb-2"
  }, [_c('b-button', {
    staticClass: "mt-2",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.UpdateMessageStatus()
      }
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('b-button', {
    staticClass: "mt-2",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.hideUpdateMessageStatusModal
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-273d1e22","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/allModuleForm/allMessageForm.vue
// module id = 2472
// module chunks = 0